import React from 'react';
import PropTypes from 'prop-types';

const HorizontalWrapper = ({
  children,
  display,
  additionalStyles = {},
  alignItems = 'normal',
  justifyContent = 'flex-start',
}) => {
  const styles = { horizontal: { alignItems, display, justifyContent, ...additionalStyles } };
  return <div style={styles.horizontal}>{children}</div>;
};

HorizontalWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  display: PropTypes.oneOf(['block', 'inline-block', 'inline', 'inline-flex', 'flex']).isRequired,
  additionalStyles: PropTypes.object,
  alignItems: PropTypes.string,
  justifyContent: PropTypes.oneOf(['stretch', 'flex-start', 'center', 'flex-end', 'space-between']),
};

export default HorizontalWrapper;
